package com.routexk.quiz.ui.sections.header.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.routexk.quiz.ui.sections.header.SideMenuSlideInAnim
import com.routexk.quiz.ui.sections.header.SideMenuState
import com.routexk.quiz.ui.theme.AppColors
import com.routexk.quiz.ui.utils.Constants
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Composable
internal fun SideMenu(
    menuState: SideMenuState,
    close: () -> Unit,
    onAnimationEnd: () -> Unit
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Overlay(
        Modifier
            .setVariable(OverlayVars.BackgroundColor, colors.overlay)
            .onClick { close() }
    ) {
        key(menuState) {
            Column(
                Modifier
                    .fillMaxHeight()
                    .width(280.px)
                    .align(Alignment.CenterEnd)
                    .padding(2.cssRem)
                    .gap(2.cssRem)
                    .backgroundColor(colors.surface)
                    .animation(
                        SideMenuSlideInAnim.toAnimation(
                            duration = Constants.ANIMATION_NORMAL.ms,
                            timingFunction = if (menuState == SideMenuState.OPEN) {
                                AnimationTimingFunction.EaseOut
                            } else {
                                AnimationTimingFunction.EaseIn
                            },
                            direction = if (menuState == SideMenuState.OPEN) {
                                AnimationDirection.Normal
                            } else {
                                AnimationDirection.Reverse
                            },
                            fillMode = AnimationFillMode.Forwards
                        )
                    )
                    .borderRadius(topLeft = 1.cssRem, bottomLeft = 1.cssRem)
                    .onClick { it.stopPropagation() }
                    .onAnimationEnd { onAnimationEnd() },
                horizontalAlignment = Alignment.End
            ) {
                CloseButton(onClick = { close() })
                Column(
                    Modifier
                        .gap(1.5.cssRem)
                        .fontSize(1.2.cssRem),
                    horizontalAlignment = Alignment.End
                ) {
                    MenuItems(onItemClick = { close() })
                }
            }
        }
    }
}
